<template>
  <div class="help" v-html="content" />
</template>
    
<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

export default {
  name: "HelpPanel",
  computed: {
    ...mapGetters({
      content: "getHelpContent",
    }),
  },
};
</script>
    
<style lang="scss" scoped>
.help {
  padding: 0 $qvo-spacing-24;
}
</style>